import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchPracticeInfoProviders = createAsyncThunk(
    "fetchPracticeInfoProviders",
    async (practiceId) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/providers?view=brief`);
        return result;
    }
)


export const fetchSearchedProviders = createAsyncThunk(
    "fetchSearchedProviders",
    async ({searchType,query,state}) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/providers?fields=(${searchType})&option=literal&query=${query}&state=${state || "all"}&view=search`);
        return result;
    }
);


export const fetchAddPracticeInfoProviders = createAsyncThunk(
    "fetchAddPracticeInfoProviders",
    async ({practiceId,displayId}) => {
        const result = await FetchRequestHandler("post",`${baseUrl}api/practices/${practiceId}/providers/${displayId}`);
        return result;
    }
)


export const fetchReasonCodeActive = createAsyncThunk(
    "fetchReasonCodeActive",
    async () => {
        const result = await FetchRequestHandler("get",`${baseUrl}api/reason-codes?entity=access-point&status=active`);
        return result;
    }
)



export const fetchUpdateStatus = createAsyncThunk(
    "fetchUpdateStatus",
    async ({providerDisplayId,practiceId,payload}) => {
        const result = await FetchRequestHandler("put",`${baseUrl}api/providers/${providerDisplayId}/practices/${practiceId}/status`,payload);
        return result;
    }
)
